module.exports = __webpack_public_path__ + "img/wandh-case-active.2611e78.svg";